import { DivisionMetadata } from "../../models/ordering/enums/division";
import { ShipmentMethod, ShipmentMethodMetadata } from "../../transportation/models/enums/shipment-method";
import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../models/utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../models/utilities/list-header";
import { PageData } from "../../models/utilities/paged-request";
import { ApiEndpoints } from "../../utils/app-constants";
import { AppUtils } from "../../utils/app-utils";

export class MetricsSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(500);
    public baseUrl          : string = ApiEndpoints.PRODUCTION_METRICS_ORDERS;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {

        // Set our table columns
        this.columns = [];

        // Create our Filter Groups
        const byDate = this.buildMaxCutoff();
        const byDealer = this.buildDealer();
        const byDivision = this.buildDivision();
        const byShipmentMethod = this.buildShipmentMethod();
        
        this.filters.push(
            byDate, byDealer, byDivision, byShipmentMethod
        );

    }

    // #region Group Builders

    private buildMaxCutoff() {
        const byDate = new FilterGroup('Max Cutoff', 'dateplus', 'maxCutoff');        
        const opt1 = new FilterBarInputOpt('Max Cutoff', {
            selectedDate: {
                qsValue: new Date(),
                qsName: 'maxCutoff'
            },
            checkboxValue: {
                qsValue: false,
                qsName: 'matchDayOfWeek'
            }
        });
        
        byDate.opts = [opt1];

        return byDate;
    }

    private buildDealer() {
        const byDealer = new FilterGroup('Dealer', 'dealer', 'dealerId');        
        const opt1 = new FilterBarInputOpt('Dealer', '');
        
        byDealer.opts = [opt1];

        return byDealer;
    }

    private buildDivision() {
        const byDivision = new FilterGroup('Division', 'checkboxes', 'division');
        byDivision.opts = AppUtils.enumMetadataToFilters(DivisionMetadata);

        return byDivision;
    }

    // The orders that are picked up are what is listed until the deliveries are asked for too.  An order that is sent by
    // Fedex is not planned here, so it is not one to choose.
    private buildShipmentMethod() {
        const byShipmentMethod = new FilterGroup('Shipment Method', 'checkboxes', 'shipmentMethod');
        byShipmentMethod.opts = [ShipmentMethod.Delivery, ShipmentMethod.PickUp].map((method: ShipmentMethod) =>
            new FilterBarInputOpt(
                ShipmentMethodMetadata[method].display,
                method === ShipmentMethod.PickUp,
                ShipmentMethodMetadata[method].value
            ));

        return byShipmentMethod;
    }    

    // #endregion

}
